import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { motion } from 'framer-motion';

export default function Breadcrumbs({ items }) {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <motion.ol 
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3 }}
        className="flex items-center space-x-2 sm:space-x-4 bg-surface px-4 py-2 rounded-xl shadow-sm border border-workspace"
      >
        <li>
          <div>
            <Link
              to="/"
              className="text-tertiary hover:text-primary transition-colors flex items-center"
            >
              <Home className="h-4 w-4" />
              <span className="sr-only">Accueil</span>
            </Link>
          </div>
        </li>
        
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          return (
            <li key={index}>
              <div className="flex items-center">
                <ChevronRight className="h-4 w-4 text-tertiary/60 mx-1 flex-shrink-0" />
                {isLast || !item.path ? (
                  <span className="ml-1 text-sm font-semibold text-primary truncate max-w-[150px] sm:max-w-xs" aria-current="page">
                    {item.label}
                  </span>
                ) : (
                  <Link
                    to={item.path}
                    className="ml-1 text-sm font-medium text-tertiary hover:text-primary transition-colors"
                  >
                    {item.label}
                  </Link>
                )}
              </div>
            </li>
          );
        })}
      </motion.ol>
    </nav>
  );
}
